import { useRef, useEffect } from 'react';
export function useIsMounted() {
  var isMountedRef = useRef(false);
  useEffect(function () {
    isMountedRef.current = true;
    return function () {
      isMountedRef.current = false;
    };
  }, []);
  return isMountedRef.current;
}